import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { PatientService } from 'src/app/services/patient.service';
import { ApiResult } from '../../../models/PromiseResult';
import { GraphqlService } from 'src/app/services/graphql.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';


export class DietDataType {
    id: number = 0;
    image_url: string = "";
    consultation_name: string = "";
    amount: string = "";
    number_of_consultations: number = 0;
    description: string = "";
    description_list: string[] = [];
    raw_amount: string = "";
}

export class DietData {
    amount: string = "";
    no_of_consultations: number = 0;
    diet_plan_name: string = "";
    striked_amount: string = "";

    constructor(amount: string = "", no_of_consultations: number = 0, diet_plan_name: string = "", striked_amount: string = "") {
        this.amount = amount;
        this.no_of_consultations = no_of_consultations;
        this.diet_plan_name = diet_plan_name;
        this.striked_amount = striked_amount;
    }
}

@Component({
    selector: 'app-diet-section',
    templateUrl: './diet-section.component.html',
    styleUrls: ['./diet-section.component.css']
})
export class DietSectionComponent implements OnInit {
    diet_plan_list: DietDataType[] = [];
    dietdata: any;
    diet_data: DietData[] = [new DietData(), new DietData(), new DietData(),];
    percents_off: number[] = [17, 25, 23]
    slug: string = "";
    display = false;
    display1: boolean = false;
    posting: boolean = false;
    freeDietPrice: string = '';

    apiResult: ApiResult = new ApiResult();
    constructor(
        private readonly patientService: PatientService,
        private readonly graphqlService: GraphqlService,
        private readonly providerstateService: ProviderStateService
    ) { }

    async ngOnInit(): Promise<void> {
        this.slug = this.providerstateService.getProviderSlug();
        await this.getDietPlans();
        await this.getDietData();
        await this.getFreeDietData();
    }

    formatPrice(number: number, currencySymbol: string) {
        // Format the number with commas and two decimal places
        const formattedNumber = number
            .toFixed(2) // Ensure two decimal places
            .replace(/\B(?=(\d{3})+(?!\d))/g, ','); // Add commas as thousand separators

        // Return the formatted string with the currency symbol
        return `${currencySymbol}${formattedNumber}`;
    }

    parsePriceString(priceString: string) {
        // Extract the currency symbol (non-numeric characters at the start)
        const currencySymbol = priceString.match(/^[^\d]+/)[0].trim();

        // Extract the numeric value by removing all non-numeric characters except . and -
        const numberValue = parseFloat(priceString.replace(/[^\d.-]/g, ''));

        return { currencySymbol, numberValue };
    }

    async getDietPlans() {
        await this.patientService
            .getAllDietPlans()
            .toPromise()
            .then((result) => {
                this.apiResult.PromiseResult = result;
                if (result.success) {
                    this.diet_plan_list = result.data.plans;
                    this.diet_plan_list.forEach((ele) => {
                        ele.description_list = ele.description.split("\r\n");
                    });
                };
                this.display1 = true;
            })
            .catch((error: HttpErrorResponse) => {
                this.apiResult.PromiseResult.success = false;
                this.apiResult.ServerError = error.error;
            });
    }

    async getDietData() {
        this.graphqlService.getDietData().subscribe(
            (result) => {
                this.posting = true;
                this.dietdata = result.data;
                for (let i = 0; i < result.data.findPriorityTypes.length; i++) {
                    const { currencySymbol, numberValue } = this.parsePriceString(
                        result.data.findPriorityTypes[i].renderedAmount
                    );
                    const strikedAmount = Math.ceil((numberValue * 100) / (100 - this.percents_off[i]))
                    const strikedRenderedAmount = this.formatPrice(strikedAmount, currencySymbol)
                    this.diet_data[i] = {
                        amount: result.data.findPriorityTypes[i].renderedAmount,
                        no_of_consultations: result.data.findPriorityTypes[i].number_of_consultations,
                        diet_plan_name: result.data.findPriorityTypes[i].consultation_name,
                        striked_amount: strikedRenderedAmount

                    }
                }
                // this.amount_1 = result.data['findPriorityTypes'][0]['amount'];
                // this.amount_2 = result.data['findPriorityTypes'][1]['amount'];
                // this.amount_3 = result.data['findPriorityTypes'][2]['amount'];
                // this.no_of_consultations_1 = result.data['findPriorityTypes'][0]['number_of_consultations'];
                // this.no_of_consultations_2 = result.data['findPriorityTypes'][1]['number_of_consultations'];
                // this.no_of_consultations_3 = result.data['findPriorityTypes'][2]['number_of_consultations'];
                // this.diet_plan_name1 = result.data['findPriorityTypes'][0]['consultation_name'];
                // this.diet_plan_name2 = result.data['findPriorityTypes'][1]['consultation_name'];
                // this.diet_plan_name3 = result.data['findPriorityTypes'][2]['consultation_name'];
            },
            (error) => {
                console.error('There was an error fetching the count from the API', error);
            }
        );
    }

    async getFreeDietData() {
        await this.patientService
            .getFreeDietPriceData()
            .toPromise()
            .then((result) => {
                if (result.success) {
                    this.freeDietPrice = result.data.free_diet_plan_banner_price
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

}
